import { createAction } from '@ngrx/store';

export const clearLast = createAction('[Notification] Clear Last');

export type ApiActions = ReturnType<typeof clearLast>;
